import { graphql } from "api/cms-website/generated";

export const IllustratedListFragment = graphql(/* GraphQL */ `
    fragment IllustratedListFragment on ComponentComponentsIllustratedList {
        id
        noMarginBottom
        illustratedListTitle: title
        illustratedListSubtitle: subtitle
        illustratedListText: text
        illustratedListCta: cta {
            ...ButtonFragment
        }
        mainCTA {
            ...ButtonFragment
        }
        withNumberHeading
        withHeaderCta
        withMobileCta
        withDivider
        withExpandableText
        illustratedListItems: items {
            ...ColumnFragment
        }
    }
`);
